import { useMemo } from "react";

/**
 * Demo mode is activated via ?demo=true URL parameter.
 * Once activated, it persists for the browser session via sessionStorage.
 * Deactivate with ?demo=false.
 */
export function useDemoMode() {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("demo") === "true") {
      sessionStorage.setItem("589_demo", "1");
    } else if (params.get("demo") === "false") {
      sessionStorage.removeItem("589_demo");
    }
    return sessionStorage.getItem("589_demo") === "1";
  }, []);
}
